// extracted by mini-css-extract-plugin
module.exports = {"root":"_23f1e0","percentage":"_c94205","percentageSymbol":"_f7a3d6","textVariation":"_80251b","recommendText":"_b17ade","recommendTextHide":"_bbb04e"};